import "cookieconsent"

export default {
	init() {
		window.cookieconsent.initialise({
			palette: {
				popup: {
					background: '#155E67',
					text: '#fff',
				},
				button: {
					background: '#fff',
					text: '#000',
				},
			},
			theme: 'classic',
			// Privzeta predloga + notranji ovoj, da je vsebina bannerja poravnana
			// s container-wide vsebino strani (postavitev je v _cookieconsent.scss).
			window: '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><div class="cc-inner container-wide"><!--googleoff: all-->{{children}}<!--googleon: all--></div></div>',
			content: {
				message: my_ajax_object.cookies_text,
				href: my_ajax_object.cookies_url,
				link: my_ajax_object.cookies_title,
				dismiss: my_ajax_object.cookies_dismiss,
			},
		});
	}
};
